import { render } from "./ProjectAttachmentForm.vue?vue&type=template&id=26e33789&scoped=true&ts=true"
import script from "./ProjectAttachmentForm.ts?vue&type=script&lang=ts"
export * from "./ProjectAttachmentForm.ts?vue&type=script&lang=ts"

import "./ProjectAttachmentForm.scss?vue&type=style&index=0&id=26e33789&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26e33789"]])

export default __exports__